const MAX_GEOCODING_DELAY = 4000 // 4 seconds (due to geometric progression, it will effectively attempt 5 times before timing out)

export default {
  methods: {
    submitIfReady(submitFunction) {
      if (this.pendingGeocoding) {
        this.waitUntilReadyAndSubmit(250, submitFunction)
      } else {
        submitFunction()
      }
    },

    waitUntilReadyAndSubmit(delay, submitFunction) {
      // Wait for the location to be automatically geocoded
      if (!this.pendingGeocoding || delay >= MAX_GEOCODING_DELAY) {
        if (delay >= MAX_GEOCODING_DELAY) {
          // We submit the request anyways
          this.$errorLogger.error('Could not geocode location before submitting.')
        }

        submitFunction()
        return
      }

      setTimeout(this.waitUntilReadyAndSubmit, delay, delay * 2, submitFunction)
    }
  }
}
